var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoidIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000000",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 2.5H17L22 7.5V13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 2.5V7.5H22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 2.5C4.3 2.5 3.5 3.7 3.5 5.5V26C3.5 27.8 4.5 29 6 29H13.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12H16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.5H14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 21H12"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000000",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 6.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 27.5L27.5 18.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoidIcon);
export default __webpack_public_path__ + "static/media/void-icon.c34e9510397d27400078d02d645c512f.svg";
export { ForwardRef as ReactComponent };